<template>
  <div id="nav"></div>
  <router-view />
</template>

<style lang="scss">
@import "./sass/main.scss";
</style>
<script>
import store from "./store";

export default {
  setup() {
    store.dispatch("proyectos/obtenerTodosLosProyectos");
    store.dispatch("proyectos/obtenerProyectosUsuarios");
    store.dispatch("categorias/obtenerCategorias");
    store.dispatch("blog/obtenerArticulos");
    store.dispatch("notificaciones/obtenerNotificaciones")

}
}
</script>
